import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const setCalTagActiveInputSchema = z.object({
    id: requiredUuidString('Tag is required.', 'Invalid tag ID.'),
    active: z.boolean(),
});
//# sourceMappingURL=set-cal-tag-active-input.js.map